var ebook4i = function(){
	var loadDetails = document.getElementById("itemDetails") ? document.getElementById("itemDetails") : "",
	ebookItems = [].slice.call(document.querySelectorAll(".item")),
	currentURL = window.location.href,
	itemIDNumber = currentURL.split('#')[1] ? currentURL.split('#')[1] : "",
	
	init = function(){
		ebookItems.forEach(function(ebookItem){
			ebookItem.addEventListener("click", loadEbookInfo);
		});
		
		if(itemIDNumber !== ""){
			var itemID = "item_" + itemIDNumber;
			document.getElementById(itemID).click();
		}else if(typeof ebookItems[0] !== 'undefined'){
			ebookItems[0].click();
		} 
	},
	loadEbookInfo = function(e){
		e.preventDefault();
		var ebookItemClicked = e.currentTarget;
		var data = ebookItemClicked.getAttribute("data-section-item");	
		var itemInfo = JSON.parse(data);
		loadDetails.innerHTML = ""; //remove old html if loaded already
		loadDetails.insertAdjacentHTML("afterbegin", getDetailHTML(itemInfo)); // load into the detail section
		loadDetails.scrollIntoView({behavior: "smooth"});
	},
	getDetailHTML = function(itemDetails){	
		var sectionName = itemDetails.SectionName,
		customerNameLocation = itemDetails.CustNameLocation,
		//customerLocation = itemDetails.CustLocation,
		productName = itemDetails.ProductName,
		productAlias = itemDetails.CatAlias,
		productImg = itemDetails.ProductImage,
		swaggingImage = itemDetails.SwagProductImage,
		customerTestimony = itemDetails.CustTestimony,
		employeeInfo = itemDetails.EmployeeInfo,
		shopURL = itemDetails.ProductShopUrl,
		//socialShareURL = itemDetails.SectionItemShareUrl,
		textColor = itemDetails.ColorClass
		//facebookShare = "window.open('https://www.facebook.com/sharer/sharer.php?u=" + itemDetails.SectionItemShareUrl + "','facebook-share-dialog','width=626,height=436'); return false;";

		
		var detailHTML = 
			'<div class="margin5 padding10 borderDkGray borderRadius10">' +
				'<h3 class="textSemiBold text30 ' + textColor + '">' +  sectionName + '</h3>' +
	            		'<p class="text20 textSemiBold tinySpace">' + customerNameLocation + '</p>' +
	          		'<p class="text16">' + productName + '<br>Item #' + productAlias + '</p>';
				if(employeeInfo !== ""){ // only add this HTML if there's an employee in the main image
					detailHTML += '<p class="text14 marginTop10 c-md-3, c-sm-quarter-4 c-xs-full">' + employeeInfo + '</p>';
				}
				detailHTML +=
	                 	'<img class="responsiveImg marginTop10 marginBtm10" width="400" height="400" src="' + productImg + '" alt="' + productName + '">' +
	                    '<p class="text16">' + customerTestimony + '</p>' +
	                  	'<a class="marginTop20 marginBtm20 button-md bkgdWhite text16" href="' + shopURL + '"><span>Shop <span class="visually-hidden"> the ' + productName + ' </span>Now</span></a>' +
	                  	'<div class="displayFlex">' +
	                    		'<div class="c-md-quarter-2 c-sm-quarter-4 c-xs-full">' +
	                            	//'<a class="noLine inlineMiddle" target="_blank" rel="noopener" href="#" onclick="' + facebookShare + '" aria-label="Share ' + productName + ' on Facebook opens in new window"><svg class="padding5" height="35px" width="35px" focusable="false"><use xlink:href="#svgIcon-facebook"></use></svg></a>' +
	                            	//'<a class="noLine inlineMiddle" href="https://twitter.com/share?url=' + socialShareURL + '" target="_blank" rel="noopener" aria-label="Share ' + productName + ' on Twitter opens in new window"><svg class="padding5" height="35px" width="35px" focusable="false"><use xlink:href="#svgIcon-twitter"></use></svg></a>' +
	                            	//'<a class="noLine inlineMiddle" href="https://www.pinterest.com/pin/create/button/?url=' + socialShareURL + '&amp;media=' + productImg + ' target="_blank" rel="noopener" aria-label="Share ' + productName + ' on Pinterest opens in new window"><svg class="padding5" height="35px" width="35px" focusable="false"><use xlink:href="#svgIcon-pinterest"></use></svg></a>' +
	                            	//'<a class="noLine inlineMiddle" href="https://www.linkedin.com/shareArticle?mini=true&amp;url=' + socialShareURL + '" target="_blank" rel="noopener" aria-label="Share ' + productName + 'on LinkedIn opens in new window"><svg class="padding5" height="35px" width="35px" focusable="false"><use xlink:href="#svgIcon-linkedIn"></use></svg></a>' +
	                        	'</div>';
	                        	                        					
	           	if(swaggingImage !== ""){ // only add this HTML if there's a swaggingrights image
	      			detailHTML += '<div class="c-md-quarter-2 c-sm-quarter-4 c-xs-full">' +
	                            	'<h2 class="featHdrText fullWidth borderTopMdGray">#SwaggingRights<sup>&reg;</sup></h2>' +
	                            	'<img class="responsiveImg marginBtm10" src="' + swaggingImage + '" alt="' + productName + '">' +
	                        	'</div>';
	              }
	     		detailHTML += '</div>';
		return detailHTML;
	};

	return{
		Init: init
	};
};

(function(){
	var ebookPage = new ebook4i();
	ebookPage.Init();
})();